<template>
    <div class="mt-2">
        <div>
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">fa-phone</v-icon>
                    Phone Numbers
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <EditPersonPhoneNumberDialog
                    :person-id="personId"
                    v-if="personId !== undefined"
                />
                <AddPersonPhoneNumberDialog
                    :person-id="personId"
                    v-if="personId !== undefined"
                />
            </v-toolbar>
            <v-data-table
                :headers="personPhoneNumberTableHeaders"
                :items="personPhoneNumberList"
                class="elevation-1"
                v-if="person !== undefined"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <tr>
                        <td class="text-xs-left">{{ props.item.contactNumber }}</td>
                        <td class="text-xs-left">{{ props.item.type }}</td>
                        <td class="text-xs-left">{{ props.item.category }}</td>
                        <td class="text-xs-left">{{ props.item.showInContactList === true ? 'Yes' : 'No ' }}</td>
                        <td class="justify-center layout px-0">
                            <v-icon
                                @click="editItem(props.item)"
                                class="mr-2"
                                small
                                style="display: inline-flex;"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                @click="deleteItem(props.item)"
                                small
                                style="display: inline-flex;"
                            >
                                delete
                            </v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import {DELETE_PERSON_PHONE_NUMBER, FETCH_PERSON_PHONE_NUMBER_LIST,} from "@/store/person_phone_number/actions.js";
    import EditTableFunctions from '../editTableFunctions';
    import {LOAD_PERSON_PHONE_NUMBER_TO_EDIT, LOAD_PERSON_PHONE_NUMBER_TO_VIEW, TOGGLE_EDIT_PERSON_PHONE_NUMBER_DIALOG, TOGGLE_VIEW_PERSON_PHONE_NUMBER_DIALOG} from "@/store/person_phone_number/mutations.js";

    import AddPersonPhoneNumberDialog from "./AddPersonPhoneNumberDialog";
    import EditPersonPhoneNumberDialog from "./EditPersonPhoneNumberDialog";

    export default {
        name: "PersonPhoneNumbersTable",
        components: {AddPersonPhoneNumberDialog, EditPersonPhoneNumberDialog},
        mixins: [
            EditTableFunctions,
        ],
        props: {
            personId: {
                type: Number,
                required: true,
            }
        },
        data() {
            return {
                idName: 'personPhoneNumberId',
                dialog: false,
                personPhoneNumberTableHeaders: [
                    {text: 'Contact Number', value: 'contactNumber'},
                    {text: 'Type', value: 'type'},
                    {text: 'Category', value: 'category'},
                    {text: 'Show in Contact List', value: 'showInContactList'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                rowsPerPageItems: [10, 20, 50, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],
                pagination: {
                    rowsPerPage: 10
                },
                editedId: -1,
            }
        },

        computed: {
            editEmergencyContactTypeId: {
                get() {
                    return this.$store.state.personPhoneNumber.editPersonPhoneNumber.emergencyContactTypeId;
                },
                set(value) {
                    this.updateValue('emergencyContactTypeId', value);
                },
            },
            editWeeklyHours: {
                get() {
                    return this.$store.state.personPhoneNumber.editPersonPhoneNumber.weeklyHours;
                },
                set(value) {
                    this.updateValue('weeklyHours', value);
                },
            },
            editStartDate: {
                get() {
                    return this.$store.state.personPhoneNumber.editPersonPhoneNumber.startDate;
                },
                set(value) {
                    this.updateValue('startDate', value);
                },
            },
            editEndDate: {
                get() {
                    return this.$store.state.personPhoneNumber.editPersonPhoneNumber.endDate;
                },
                set(value) {
                    this.updateValue('endDate', value);
                },
            },
            editComments: {
                get() {
                    return this.$store.state.personPhoneNumber.editPersonPhoneNumber.comments;
                },
                set(value) {
                    this.updateValue('comments', value);
                },
            },
            ...mapGetters(
            [
                "person",
                "personPhoneNumberList",
                "getBankDetailTypeNameById",
                "getPersonnelCountryNameById",
                // "emergencyContactTypeList",
            ]
            )
        },

        mounted() {

        },

        methods: {
            ...mapActions({
                fetchTableList: FETCH_PERSON_PHONE_NUMBER_LIST,
                deleteTableItem: DELETE_PERSON_PHONE_NUMBER,
            }),

            ...mapMutations({
                loadTableItemToEdit: LOAD_PERSON_PHONE_NUMBER_TO_EDIT,
                loadTableItemToView: LOAD_PERSON_PHONE_NUMBER_TO_VIEW,
                toggleEditDialog: TOGGLE_EDIT_PERSON_PHONE_NUMBER_DIALOG,
                toggleViewDialog: TOGGLE_VIEW_PERSON_PHONE_NUMBER_DIALOG,
            })
        },
    }
</script>

<style scoped>
</style>
